'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsonschema = require('jsonschema');
var helpers = require('jsonschema/lib/helpers');
var schemaMismatchError = require('./schema-mismatch-error.js');

class BaseBus {
  constructor() {
    this._subscriptions = new Map();
    this.loggingEnabled = false;
  }
  enableLogging() {
    this.loggingEnabled = true;
  }
  disableLogging() {
    this.loggingEnabled = false;
  }
  disableHistory(channel) {
    var _a;
    const channelData = this._subscriptions.get(channel);
    if (!channelData) {
      return;
    }
    channelData.__keepHistory = false;
    if (((_a = channelData.__payloadsHistory) == null ? void 0 : _a.length) === 2) {
      channelData.__payloadsHistory[1] = null;
    }
  }
  register(channel, schema) {
    const shouldCreate = !this._subscriptions.has(channel);
    if (shouldCreate) {
      this.initChannel(channel);
    }
    const registered = this.getSchema(channel);
    if (registered && !helpers.deepCompareStrict(registered, schema)) {
      throw new schemaMismatchError.SchemaMismatchError(channel, registered, schema);
    }
    this.setSchema(channel, schema);
    return shouldCreate;
  }
  unregister(channel) {
    const exists = !!this.getSchema(channel);
    if (exists) {
      delete this._subscriptions.get(channel).__schema;
    }
    return exists;
  }
  getSchema(channel) {
    var _a;
    return (_a = this._subscriptions.get(channel)) == null ? void 0 : _a.__schema;
  }
  getLatest(channel) {
    return this.getHistory(channel)[0];
  }
  log(...data) {
    if (!this.loggingEnabled) {
      return;
    }
    console.log(...data);
  }
  setSchema(channel, schema) {
    if (!this._subscriptions.has(channel)) {
      this.initChannel(channel);
    }
    this._subscriptions.get(channel).__schema = schema;
  }
  setLatest(channel, payload) {
    if (!this._subscriptions.has(channel)) {
      this.initChannel(channel);
    }
    const history = this.getHistory(channel);
    if (this.shouldKeepHistory(channel)) {
      history[1] = history[0];
    } else {
      history[1] = null;
    }
    history[0] = payload;
  }
  isDuplicateValueEmitted(channel) {
    const history = this.getHistory(channel);
    if (!this.shouldKeepHistory(channel)) {
      return false;
    }
    return (history == null ? void 0 : history.length) === 2 && history[0] === history[1];
  }
  initChannel(channel) {
    this._subscriptions.set(channel, {
      __payloadsHistory: []
    });
  }
  getHistory(channel) {
    var _a, _b;
    return (_b = (_a = this._subscriptions.get(channel)) == null ? void 0 : _a.__payloadsHistory) != null ? _b : [];
  }
  shouldKeepHistory(channel) {
    var _a, _b;
    return (_b = (_a = this._subscriptions.get(channel)) == null ? void 0 : _a.__keepHistory) != null ? _b : true;
  }
  isPayloadInvalid(channel, payload) {
    const schema = this.getSchema(channel);
    return typeof payload !== "undefined" && !!schema && !jsonschema.validate(payload, schema).valid;
  }
}

exports.BaseBus = BaseBus;
